/**
 * Build-time and storage constants. Mirrors scripts/web/src/lib/constants.js
 * so the two front-ends can be deployed against the same backend during
 * the cutover window without trampling each other's localStorage.
 */
export const API_BASE_URL = import.meta.env.DEV
  ? "http://localhost:8000"
  : "https://tornbot.mcgoldric.com";

export const TORN_API_URL = "https://api.torn.com/v2";

// Distinct prefix from the legacy Svelte app so users can flip between
// them in dev without losing each other's session.
const STORAGE_PREFIX = "tornbot_web2_";
export const API_KEY_STORAGE = STORAGE_PREFIX + "apikey";
export const SELECTED_FACTION_STORAGE = STORAGE_PREFIX + "selected_faction";
export const THEME_STORAGE = STORAGE_PREFIX + "theme";
